import fetch from '../utils/fetch';

const BaseUrl = process.env.MONO_BASE;
const BasePrefix = '/graphics';

const getUrl = (path) => `${BaseUrl}${BasePrefix}${path}`;

export default {
  /**
   * Get list of graphic templates, paginated.
   * @param {Object} opts
   * @param {Number} opts.page - Page number to fetch.
   * @param {Number} opts.limit - Number of results per page.
   * @param {String} opts.sortBy - Field to sort by.
   * @param {String} opts.sortDir - Direction to sort by. One of 'asc' or 'desc'.
   * @param {Array} opts.tags - Array of tags to filter by.
   * @returns {Promise} Promise resolving to list of templates.
   */
  getTemplates(opts = {}) {
    const {
      page = 1,
      limit = 10,
      sortBy,
      sortDir,
      tags = [],
    } = opts;

    return fetch(getUrl('/templates'), {
      query: {
        page,
        limit,
        sortBy,
        sortDir,
        tags: tags.join(','),
        legacySearch: true,
      },
    });
  },

  /**
   * Fetch a single graphic template by ID.
   * @param {Number} id - Template ID.
   * @param {Array} fields - Optional array of fields to return.
   *  If not provided, all fields are returned.
   *  @returns {Promise} Promise resolving to template object.
   */
  getTemplate(id, fields) {
    return fetch(getUrl(`/templates/${id}`), {
      query: {
        fields: fields?.join(',') || null,
      },
    });
  },

  /**
   * Create a new graphic template.
   * @param {Object} fields - Fields to set on new template.
   * @returns {Promise} Promise resolving to newly created template.
   */
  createTemplate(fields = {}) {
    return fetch(getUrl('/templates'), {
      method: 'POST',
      body: fields,
    });
  },

  /**
   * Edit an existing template by ID and partial.
   * @param {Number} id - Template ID.
   * @param {Object} fields - Fields to update on template.
   * @returns {Promise} Promise resolving to updated template.
   */
  updateTemplate(id, fields = {}) {
    return fetch(getUrl(`/templates/${id}`), {
      method: 'PUT',
      body: fields,
    });
  },

  /**
   * Delete a template by ID.
   * @param {Number} id - Template ID.
   * @returns {Promise} Promise resolving to deletion result.
   */
  deleteTemplate(id) {
    return fetch(getUrl(`/templates/${id}`), { method: 'DELETE' });
  },
};
